import React from "react";
import ImageGallery from "../components/ImageGallery";

function PaysagePage() {
  return <ImageGallery category="paysage" />;
}

export default PaysagePage;
